[
  {
    "key": "none",
    "name": "None",
    "yields": { "food": 0, "production": 0, "gold": 0 },
    "movementCost": 0,
    "defenceBonus": 0,
    "validTerrain": [],
    "colour": "#00000000",
    "description": "No feature."
  },
  {
    "key": "forest",
    "name": "Forest",
    "yields": { "food": -1, "production": 2, "gold": 0 },
    "movementCost": 1,
    "defenceBonus": 25,
    "validTerrain": ["grassland", "plains", "tundra", "hills"],
    "colour": "#35652F",
    "description": "Timber and cover. Slows an army and rewards a patient one."
  },
  {
    "key": "rainforest",
    "name": "Rainforest",
    "yields": { "food": 0, "production": 0, "gold": 0 },
    "movementCost": 2,
    "defenceBonus": 25,
    "validTerrain": ["grassland", "plains"],
    "colour": "#1F5228",
    "description": "Dense, wet and near-impassable. Worth more cleared than kept — usually."
  },
  {
    "key": "marsh",
    "name": "Marsh",
    "yields": { "food": -1, "production": 0, "gold": 0 },
    "movementCost": 2,
    "defenceBonus": 0,
    "validTerrain": ["grassland", "tundra"],
    "colour": "#4A6E5E",
    "description": "Standing water and bad ground. Drainable, at a cost."
  },
  {
    "key": "oasis",
    "name": "Oasis",
    "yields": { "food": 3, "production": 0, "gold": 1 },
    "movementCost": 0,
    "defenceBonus": 0,
    "validTerrain": ["desert"],
    "colour": "#59A86B",
    "description": "Water in the waste. Cities have been founded for less."
  }
]
